interface AppConfig {
  API_ENDPOINT: string;
  BASE_URL: string;
  DEFAULT_PROFILE_IMAGE: string;
}

export const IS_DEV = false;

export const CONFIG: AppConfig = {
  // API_ENDPOINT: IS_DEV
  //   ? "http://localhost:8765/api"
  //   : "https://youractivegames.sisproj.com/api",
  // BASE_URL: IS_DEV
  //   ? "http://localhost:8765"
  //   : "https://youractivegames.sisproj.com/",

    API_ENDPOINT: IS_DEV
    ? "http://localhost:8765/api"
    : "https://www.youractivegames.com/api",
  BASE_URL: IS_DEV
    ? "http://localhost:8765"
    : "https://www.youractivegames.com/",

  DEFAULT_PROFILE_IMAGE: "default_profile_image.jpg"
};

interface States {
  [index: string]: string;
}

export const STATES: States = {
  AL: "Alabama",
  AK: "Alaska",
  AS: "American Samoa",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District Of Columbia",
  FM: "Federated States Of Micronesia",
  FL: "Florida",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MH: "Marshall Islands",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  MP: "Northern Mariana Islands",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PW: "Palau",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VI: "Virgin Islands",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming"
};
interface Genders {
  [index: number]: any;
}

export const Genders: Genders = ["Male","Female","Mix"]
